<template>
  <div class="min-w-[12rem]" :class="configData.Class ?? ''">
    <MarkupGenerator
      v-if="configData?.innerMarkup"
      :page-data="{ PageContent: [...configData.innerMarkup] as any }"
      :is-page="false"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    innerMarkup?: any;
    Class: string;
  };
}

defineProps<Props>();
</script>

<style></style>
